import React from "react";
import Dialog from "@mui/material/Dialog";
import CallScheduler, {
  SCHEDULER_PALETTES,
} from "components/common/callScheduler";

// Bottom sheet on mobile, centred dialog on larger screens.
const ScheduleCallModal = ({
  open,
  onClose,
  leadOrigin,
  mode = "light",
  title = "Talk to your RM",
  description = "Pick a date and time that works for you, and your Relationship Manager will call you.",
}) => {
  const palette = SCHEDULER_PALETTES[mode] || SCHEDULER_PALETTES.light;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-label={title}
      PaperProps={{
        sx: {
          display: "flex",
          flexDirection: "column",
          width: { xs: "100%", sm: 480 },
          maxWidth: { xs: "100%", sm: 480 },
          maxHeight: { xs: "92vh", sm: "88vh" },
          m: { xs: 0, sm: 2 },
          borderRadius: { xs: "20px 20px 0 0", sm: "20px" },
          overflow: "hidden",
          backgroundColor: palette.paper,
          backgroundImage: "none",
          border: mode === "dark" ? `1px solid ${palette.border}` : "none",
          boxShadow:
            "0px 24px 48px -16px rgba(34,43,62,0.25), 0px 2px 10px rgba(34,43,62,0.08)",
          position: { xs: "fixed", sm: "relative" },
          bottom: { xs: 0, sm: "auto" },
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          alignItems: { xs: "flex-end", sm: "center" },
        },
        ...(mode === "dark"
          ? { "& .MuiBackdrop-root": { backgroundColor: "rgba(0,0,0,0.75)" } }
          : {}),
      }}
    >
      {/* Dialog unmounts this after closing, so each open starts fresh */}
      <CallScheduler
        variant="plain"
        mode={mode}
        title={title}
        description={description}
        onClose={onClose}
        onSkip={onClose}
        isShowButton={false}
        leadOrigin={leadOrigin}
      />
    </Dialog>
  );
};

export default ScheduleCallModal;
